import type { ReactNode } from "react";

// =====================================================================
// Administration — interne SideNav.
// Spalte 220 px, gruppiert mit Mono-Uppercase-Labels. Aktiver Eintrag
// in `--cat-s` Hintergrund + 2 px linkem Akzent-Bar in `--cat`.
//
// Bewusst als kleines, autonomes Atom gehalten — die App-Hue (`--cat`)
// kommt vom `.cc-root`-Wrapper via `data-app="cc"`.
// =====================================================================

export type CCNavItem = {
  id: string;
  label: string;
  icon?: ReactNode;
  badge?: number | string;
};

export type CCNavGroup = {
  label?: string;
  items: CCNavItem[];
};

type Props = {
  groups: CCNavGroup[];
  value: string;
  onChange: (id: string) => void;
  footer?: ReactNode;
};

export function CCSideNav({ groups, value, onChange, footer }: Props) {
  return (
    <aside className="cc-sidenav" aria-label="Administration Navigation">
      {groups.map((g, idx) => (
        <div className="cc-sidenav-group" key={idx}>
          {g.label ? <div className="cc-sidenav-label">{g.label}</div> : null}
          {g.items.map((item) => {
            const active = item.id === value;
            return (
              <button
                key={item.id}
                type="button"
                className={`cc-sidenav-item${active ? " is-active" : ""}`}
                onClick={() => onChange(item.id)}
                aria-current={active ? "page" : undefined}
                data-testid={`cc-nav-${item.id}`}
              >
                {item.icon ? <span aria-hidden="true">{item.icon}</span> : null}
                <span>{item.label}</span>
                {item.badge != null ? (
                  <span className="cc-badge">{item.badge}</span>
                ) : null}
              </button>
            );
          })}
        </div>
      ))}
      <div style={{ flex: 1 }} />
      {footer ? <div style={{ paddingTop: 10, borderTop: "1px solid var(--border)" }}>{footer}</div> : null}
    </aside>
  );
}
